import React from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** Stil des Eingabefelds — jedes Formular bringt seinen eigenen mit (wie bei `SeasonSelect`). */
  inputClassName?: string;
  inputStyle?: React.CSSProperties;
  labelClassName?: string;
  labelStyle?: React.CSSProperties;
  idPrefix: string;
}

/**
 * Gebiet eines permanenten Events ohne festen Startort („Erzgebirge", „Dolomiten"). Das Backend
 * verortet es über den Geocoder und speichert Mittelpunkt und Ausdehnung; die Karte zeichnet dann
 * eine Fläche (docs/bereiche/permanente-events.md). Mit Stadt oder PLZ gilt der Ort, nicht das Gebiet.
 */
export default function AreaField({ value, onChange, inputClassName, inputStyle, labelClassName, labelStyle, idPrefix }: Props) {
  return (
    <div className="sm:col-span-2">
      <label htmlFor={`${idPrefix}-area`} className={labelClassName} style={labelStyle}>Gebiet (optional)</label>
      <input id={`${idPrefix}-area`} value={value} onChange={e => onChange(e.target.value)}
        placeholder="z. B. Erzgebirge" maxLength={120}
        className={inputClassName} style={inputStyle} />
      <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>
        Nur ausfüllen, wenn es keinen festen Startort gibt, etwa bei mehreren Einstiegspunkten.
        Das Gebiet erscheint dann als Fläche auf der Karte.
      </p>
    </div>
  );
}
